// Config
let env = 'production';
let apiHost, cpixdomain;

const location = window.location.href;
const AWS_URL = "http://s3-us-east-2.amazonaws.com/cpixmedia"

if(location.indexOf('aspen-stag') > -1) {
    env = 'staging';
}

if(location.indexOf('localhost') > -1){
    env = 'local';
}

// aspen.corelistingmachine.com
if(env === 'production'){
    apiHost = 'https://capi.corelistingmachine.com';
    cpixdomain = 'https://corelistingmachine.com';
}

// aspen-stag.corelistingmachine.com
if(env === 'staging'){
    apiHost = 'https://stag-capi.corelistingmachine.com';
    cpixdomain = 'https://staging.corelistingmachine.com';
}

// localhost
if (env === 'local') {
  apiHost = 'http://capi.test';
  cpixdomain = 'http://dev.corelistingmachine.com:8080'; //set hosts file

}

export {apiHost, cpixdomain, AWS_URL};
